import React, { Component } from 'react';
import $ from 'jquery'; 
import SearchBar from '../SearchBar/SearchBar';
import Weather from '../Weather/Weather';
import Week from '../Week/Week';

import { Route } from 'react-router-dom';

import ReactChartkick, { LineChart } from 'react-chartkick'
import Chart from 'chart.js'

ReactChartkick.addAdapter(Chart)

class App extends Component {
	state = {
		data: [],
		jsonParsed: null
	}

	componentDidMount() {
		// Lets have a dark mode, the cool kids are doing it
		var hour = new Date().getHours();
		if (hour >= 19 || hour <= 6){
			$("body").addClass("darkmode");
		}			

		this.welcomeMessage();
		
		setInterval(this.loadData.bind(this), 300000);		
	}

	welcomeMessage(){
		//fade in to hide slow api calls, and it looks nice
		$("#reading-chart").hide();
		this.loadData();
		
		$("body").fadeIn(1500);
		$("#search").fadeIn(1);
		window.setTimeout( this.gracefullyShowValues, 1500 );
	}

	loadData() {		
		fetch("https://startpage-api.webproject.za.net/api")		
			.then(response => response.json())
			.then(json => {			
				this.setState({
					data: json,
					jsonParsed: JSON.parse(json.goalChartData)
				});			
		});			
	}



	gracefullyShowValues(){		
		//transition from "loading" to showing values
		$("#loading").addClass("hidden");			
		$("#weatherMessage").removeClass("hidden");
		$(".week-frame").removeClass("hidden");
		
		//I like fades
		$("#weatherMessage").hide().fadeIn(1000);
		$(".week-frame").hide().fadeIn(1000);
		$("#reading-chart").hide().fadeIn(1000);		
	}	

	render() {
		return (
			<div>
				<div className="fadeIn">
				<SearchBar/>
				<Week data={this.state.data}/>
				<Weather data={this.state.data}/>		
				<LineChart id="reading-chart" width="99%" height="99%" points={false} colors={["#d6d6d6"]} library={{
					events: ['null'],
					layout: {
						padding: { left: 10, right: 10, top: 0, bottom: 0 }
					},
					scales: {
						xAxes: [{
						  display: false // this hides the x-axis
						}],
						yAxes: [{
							display: false // this hides the y-axis
						}]
					  }
				}} data={this.state.jsonParsed} />
				</div>	

				<Route path="/l" component={() => { window.location = 'https://coda.io/d/Life_dxG2IQpOKSO/Scratch-Page_su46p#_lucgw'; return null;} }/>
				<Route path="/w" component={() => { window.location = 'https://coda.io/d/Niteco_drCQtAclkK7/Scratch-Disk_sujXO#_luJEY'; return null;} }/>
				<Route path="/d" component={() => { window.location = 'https://dashboard.jacob.earth'; return null;} }/>
				{/* <Route path="/r" component={() => { window.location = 'https://coda.io/d/Relatively-Productive-Podcast-Planner_dXqIRu-Geh4/Add-Topic-Idea_sud3P#_luYbG'; return null;} }/> */}
			</div>
			
		);
	}
}

export default App;


// WEBPACK FOOTER //
// ./src/Components/App/App.js